import { initContract } from '@ts-rest/core';
import { addInContract } from './add-in.js';
import { claimDetailsContract } from './claim-details.js';
import { commonContract } from './common.js';
import { dashboardContract } from './dashboard.js';
import { documentsContract } from './documents.js';
import { filedClaimsContract } from './filed-claims.js';
import { newClaimContract } from './new-claim.js';
import { paymentDecisionDocumentContract } from './payment-decision-document.js';
import { paymentDocumentsContract } from './payment-documents.js';
import { pendingClaimsContract } from './pending-claims.js';
////////////////////////////////////////////////////////////////////////////////
// contract
////////////////////////////////////////////////////////////////////////////////
const c = initContract();
export const contract = c.router({
    addIn: addInContract,
    common: commonContract,
    dashboard: dashboardContract,
    pendingClaims: pendingClaimsContract,
    newClaim: newClaimContract,
    filedClaims: filedClaimsContract,
    paymentDocuments: paymentDocumentsContract,
    paymentDecisionDocument: paymentDecisionDocumentContract,
    claimDetails: claimDetailsContract,
    documents: documentsContract,
}, {
    strictStatusCodes: true,
});
